import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const ProjectService = {
    list: async () => axios.get(API_URL + "/projects/list").then(({data}) => data).catch(err => { throw err }),
    listContacts: async () => axios.get(API_URL + "/projects/list/contacts").then(({data}) => data).catch(err => { throw err }),
    listLicensing: async () => axios.get(API_URL + "/projects/list/licensing").then(({data}) => data).catch(err => { throw err }),

    getById: async (id) => axios.get(API_URL + "/projects/" + id).then(({data}) => data).catch(err => { throw err }),

    create: async (model) => axios.post(API_URL + "/projects", model).then(({data}) => data).catch(err => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/projects/" + id, model).then(({data}) => data).catch(err => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/projects/" + id).then(({data}) => data).catch(err => { throw err }),

    options: async () => axios.get(API_URL + "/projects/options").then(({data}) => data).catch(err => { throw err }),

    form_options: async (id) => axios.get(API_URL + "/projects/form_options/" + id).then(({data}) => data).catch(err => { throw err }),

    getClone: async (id) => axios.get(API_URL + "/projects/getClone/" + id).then(({data}) => data).catch(err => { throw err }),

    editClone: async (model, id) => axios.post(API_URL + "/projects/updateClone/" + id, model).then(({data}) => data).catch(err => { throw err }),
};

export default ProjectService;